import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions/ordersAction';
import * as symbols from '../../operations/symbols';
import { getBase64 } from '../../operations/operations';
import LoaderComponent from '../core/LoaderComponent';


class ReasonListModal extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  handleImageInputClick(type) {
    document.getElementById(type).click((e) => {})
  }

  componentDidMount() {
    if (!this.props.orders.deliveryReasons)
      this.props.actions.getAllDeliveryIssueReasons('deliveryIssue');
  }

  goToReasonPage(id, subtype) {
    this.props.history.push(`/order/${this.props.id}/reason/${id}/${subtype}`)
  }

  renderReasonList() {
    const { orders } = this.props;
    return (
      orders && orders.deliveryReasons && orders.deliveryReasons.map((ele, index) => {
        return (
          <div className="reason-list" key={index} onClick={() => this.goToReasonPage(ele.id, ele.subtype)}>
            {ele.name}
            <FontAwesomeIcon icon="chevron-right" className="right gray-text"/>
          </div>
        )
      })
    )
  }

  render() {
    const { isOpen, status, orders } = this.props;

    if (isOpen) {
      return (
        <div className="modal">
          { this.props.status != symbols.STATUS_DONE ? <LoaderComponent /> :
            <div className="modal-overlay modal-picture">
                <div className="modal-title align-left">
                    Tell us why you can't deliver
                    <FontAwesomeIcon icon="times" className="right" onClick={this.props.closeReasonListModal}/>
                </div>
                <div className="light-line" />
                {
                  <div className="modal-body align-left">
                    {this.renderReasonList()}
                  </div>
                }
            </div>
          }
        </div>
      )
    }
    return null
  }
}

export default withRouter(connect(
  state => ({
    errors: state.statuses.getDeliveryIssueReasons.errors,
    status: state.statuses.getDeliveryIssueReasons.status,
    orders: state.orders
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(ReasonListModal));
